export default __webpack_public_path__ + "static/media/image.alcaline-solutions.aedc11d6.png";